import {
  ArrowRight,
  Facebook,
  Instagram,
  Linkedin,
  Sparkles,
  Youtube,
} from "lucide-react";
import { productHref } from "../data/products";

const footerColumns = [
  {
    title: "PRODUCTS",
    links: [
      ["Cullath Connect", productHref("messaging")],
      ["Cullath Desk", productHref("ticketing")],
      ["Cullath Assist", productHref("remote-access")],
    ],
  },
  {
    title: "SOLUTIONS",
    links: [
      ["Team Collaboration", productHref("#")],
      ["IT Support", productHref("#")],
      ["Remote Work", productHref("#")],
      ["Internal Communication", productHref("#")],
    ],
  },
  {
    title: "RESOURCES",
    links: [
      ["Blog", "#"],
      ["Documentation", "#"],
      ["Help Center", "#"],
      ["Release Notes", "#"],
    ],
  },
  {
    title: "COMPANY",
    links: [
      ["About Us", "/about-us"],
      ["Pricing", "/pricing"],
      ["Contact Us", "/contact-us"],
      ["Privacy Policy", "/privacy-policy"],
      ["Terms & Conditions", "/terms-and-conditions"],
    ],
  },
];

export function FooterBrand({ compact = false }) {
  return (
    <a className={`hcs-footer-brand ${compact ? "hcs-footer-brand--compact" : ""}`} href="/" aria-label="Cullath home">
      <span className="hcs-footer-brand-mark">
        <img src="/cullath-logo.svg" alt="" aria-hidden="true" />
      </span>
      <span>Cullath</span>
    </a>
  );
}

export default function SiteFooter() {
  return (
    <footer className="hcs-footer">
      <div className="hcs-footer-glow hcs-footer-glow--left" aria-hidden="true" />
      <div className="hcs-footer-glow hcs-footer-glow--right" aria-hidden="true" />

      <div className="hcs-footer-container">
        <div className="hcs-footer-main">
          <div className="hcs-footer-about">
            <FooterBrand />
            <p>Connected business software for modern teams.</p>
            <span>Connect.<br />Collaborate.<br />Get Work Done.</span>
            <div className="hcs-socials" aria-label="Social links">
              <a href="#linkedin" aria-label="LinkedIn"><Linkedin size={16} /></a>
              <a href="#instagram" aria-label="Instagram"><Instagram size={16} /></a>
              <a href="#youtube" aria-label="YouTube"><Youtube size={16} /></a>
              <a href="#facebook" aria-label="Facebook"><Facebook size={16} /></a>
            </div>
          </div>

          <nav className="hcs-footer-columns" aria-label="Footer navigation">
            {footerColumns.map((column) => (
              <div className="hcs-footer-column" key={column.title}>
                <strong>{column.title}</strong>
                {column.links.map(([label, href]) => (
                  <a href={href} key={label}>{label}<ArrowRight size={13} /></a>
                ))}
              </div>
            ))}
          </nav>
        </div>

        <div className="hcs-footer-bottom">
          <span>© 2026 Cullath.</span>
          <strong><Sparkles size={13} /> Where Work Orbits.</strong>
          <span>Made for modern teams.</span>
        </div>
      </div>
    </footer>
  );
}
